var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteAddForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-462.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-form",
    transform: "translate(462.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#DCE4F4",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-form",
    transform: "translate(6.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.750000, 0.750000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,10.5 L0.75,10.5 C0.3,10.5 0,10.2 0,9.75 L0,0.75 C0,0.3 0.3,0 0.75,0 L12.75,0 C13.2,0 13.5,0.3 13.5,0.75 L13.5,9.75 C13.5,10.2 13.2,10.5 12.75,10.5 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,8.25 L3,8.25 L3,6.75 L5.25,6.75 L5.25,8.25 Z M5.25,5.25 L3,5.25 L3,3.75 L5.25,3.75 L5.25,5.25 Z M12,9 L6.75,9 L6.75,6.75 L12,6.75 L12,9 Z M12,5.25 L6.75,5.25 L6.75,3 L12,3 L12,5.25 Z",
    id: "Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12 L1.5,12 C0.675,12 0,11.325 0,10.5 L0,1.5 C0,0.675 0.675,0 1.5,0 L13.5,0 C14.325,0 15,0.675 15,1.5 L15,10.5 C15,11.325 14.325,12 13.5,12 Z M13.5,10.5 L13.5,11.25 L13.5,10.5 L13.5,10.5 Z M1.5,1.5 L1.5,10.5 L13.5,10.5 L13.5,1.5 L1.5,1.5 Z",
    id: "Shape",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteAddForm);
export default __webpack_public_path__ + "static/media/icon-rte-add-form.1f30d8c6ea1942dfc29b5d33afb7f2d0.svg";
export { ForwardRef as ReactComponent };